import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';
import { IRubricSectionDTO, RubricSectionDTO } from './rubric.section.dto';

export interface IJudgeSpecialityDTO extends IBaseEntityDTO {
  name: string;
  sections: IRubricSectionDTO[];
}

export class JudgeSpecialityDTO extends BaseEntityDTO implements IJudgeSpecialityDTO {
  name: string;
  sections: IRubricSectionDTO[];

  constructor(data?: Partial<JudgeSpecialityDTO>) {
    super(data);
    this.name = data?.name || '';
    this.sections = data?.sections
      ? data.sections.map((section) => new RubricSectionDTO(section))
      : [];
  }
}
